import * as UIActions from "./ui";
import * as UserApi from "../services/user";

// Get Booking Detail
export const getBookingDetail = (id, token) => (dispatch) => {
    return UserApi.getBookingDetail(id, token).then((res) => {
        dispatch(UIActions.appReady());
        return res;
    })
};